<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <!-- === New Publicitygroup === -->
      <b-card>
        <div slot="header">
          <h1>Support - Mail verfassen</h1>
          <div class="card-header-actions"></div>
        </div>
        <b-card-body>
          <b-row>
            <b-col lg="8">
              <b-form>
                <!-- === Mail Subject === -->
                <b-form-group
                  id="supportInputGroup1"
                  label="Betreff"
                  label-for="supportSubject"
                >
                  <b-form-input
                    id="supportSubject"
                    type="text"
                    placeholder="Betreff"
                    :state="submitted"
                    @keyup="updateOutputUrl"
                    v-model.trim="email.subject"
                  />
                </b-form-group>

                <!-- === Mail Content === -->
                <b-form-group
                  id="supportInputGroup2"
                  label="Nachricht"
                  label-for="supportText"
                >
                  <b-form-textarea
                    id="supportTest"
                    :plain="true"
                    :state="submitted"
                    v-model="email.body"
                    @keyup="updateOutputUrl"
                    rows="8"
                    placeholder="Bitte beschreiben Sie Ihr Anliegen möglichst genau. Wir nehmen in Kürze Kontakt mit Ihnen auf."
                  ></b-form-textarea>
                </b-form-group>
              </b-form>

              <!-- === Buttons === -->
              <b-button variant="primary"
                ><a
                  @click="submitted = true"
                  v-bind:href="outputUrl"
                  class="btnAnchor"
                  >Mail Senden</a
                ></b-button
              >
              <b-button @click="reset" class="ml-1" variant="danger"
                >Mail Verwerfen</b-button
              >
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showBtns: false,
      submitted: null,
      outputUrl: "",
      recipient: "support@nobugs.gmbh",
      email: {
        subject: "",
        body: "",
      },
    };
  },
  methods: {
    updateOutputUrl() {
      this.outputUrl = "mailto:" + this.recipient;
      const emailKeys = Object.keys(this.email);
      const remaining = emailKeys.filter(
        (key) => this.email[key].trim().length > 0
      );
      if (remaining.length > 0) {
        this.outputUrl += "?";
      }
      this.outputUrl += remaining
        .map((key) => `${key}=${encodeURI(this.email[key].trim())}`)
        .join("&");
    },
    reset() {
      this.email.subject = "";
      this.email.body = "";
      this.outputUrl = "";
      this.submitted = null;
      this.updateOutputUrl();
    },
  },
  created: function () {
    this.updateOutputUrl();
  },
};
</script>

<style scoped>
.btnAnchor {
  color: white;
  text-decoration: none;
}
</style>
